import React, {useState} from "react";
import './sdRadio.scss';

function SDRadio (props) {
    let cn = ['main'];
    const [check, setCheck] = useState(false);

    function clickRadio () {
        if (props.group) {
            props.changeSelect(props.index);

            return;
        }
        
        setCheck(!check);
    }

    return (
        <div className="mainRadio" onClick={() => clickRadio()}>
            {
                props.group ? 
                <div className="radioBlock">
                    <div className={`main ${props.value ? 'checked' : 'check'}`} >
                        {check}
                    </div>
                </div> :
                <div className="radioBlock">
                    <div className={`main ${check ? 'checked' : 'check'}`} >
                        {check}
                    </div>
                </div>
            }
            <div>{props.label}</div>
        </div>
    )
}

export default SDRadio;